<template>
  <div class="container member-withdraw-list">

    <div class="common-header-wrap">
      <mt-header :title="$t('Withdraw')" class="common-header">
        <mt-button slot="left" icon="back" @click="onPage('index')"></mt-button>
      </mt-header>
    </div>

    <div class="centerbox">

      <flex-line v-if="bank_length > 0" class="field-line menu-item input-wrapper" :show-border="true">
        <span class="field-name">
          {{ $t('USDT Address (opBNB)') }}</span>
        <div class="field-line-right" slot="right">
          <input class="field-input" v-model="usdt_address" disabled />
        </div>
      </flex-line>

      <flex-line class="field-line menu-item input-wrapper" :show-border="true">
        <span class="field-name">
          {{ $t('Withdrawal Amount') }}
        </span>
        <div class="field-line-right" slot="right">
          <input class="field-input" :placeholder="$t('Please enter')" type="number" v-model="amount" />
        </div>
      </flex-line>

      <flex-line class="field-line menu-item input-wrapper" :showPassword="showPassword"
        :toggleVisibility="toggleVisibility" :isPassword="true">
        <span class="field-name">
          {{ $t('Payment Password') }}
        </span>
        <div class="field-line-right" slot="right">
          <input class="field-input" :type="showPassword ? 'text' : 'password'" :placeholder="$t('Please enter')"
            type="password" v-model="password" />
        </div>
      </flex-line>

      <div class="flex" style="dmargin-top: .5rem;">
        <div class="f balance" style="text-align: left;" @click="onRetrieve">
          {{ $t('Forgot Password') }}?
        </div>
        <div class="balance">
          {{ $t('Available Balance') }}: {{ available_predeposit }}
        </div>
      </div>

      <div class="common-btn ds-button-large" @click="addWithdraw" v-if="btnShow">{{ $t('Submit') }}
      </div>
      <div class="common-btn ds-button-large" @click="goMemberbacklist" v-else>
        {{ $t('Add Recipient Account First') }}
      </div>
    </div>

    <div class="fundet">
      <div class="tit">{{ $t('Withdrawal Details') }}</div>

      <div class="pb-30" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
        <div class="list-wrapper" v-if="withdraw_list && withdraw_list.length">
          <div class="container" v-for="(item, index) in withdraw_list" :key="item.pdc_id">
            <div class="top-wrapper">
              <div class="left-wrapper">
                <label class="status">{{ item.pdc_payment_state_text }}</label>
                <label class="title">{{ $t('address') }}: {{ item.pdc_bank_no }}</label>
              </div>
              <div class="right-wrapper">
                <label class="price">${{ item.pdc_amount }}</label>
                <label class="subtitle">{{ $t('Withdrawal Amount') }}</label>
              </div>
            </div>
            <div class="center-wrapper" v-if="item.reason">
              <label class="desc" style="color: #FB2630;">{{ $t('Cause of failure') }}: {{ item.reason }}</label>
            </div>
            <div class="center-wrapper">
              <label class="desc">{{ $t('Application Time') }}: {{ item.pdc_addtime_text }}</label>
            </div>
          </div>
        </div>
        <empty-record v-else-if="withdraw_list && !withdraw_list.length"></empty-record>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getWithdrawList, addWithdraw } from '../../../api/memberWithdraw'
import { getMemberIndex } from '../../../api/member'
import { getBankList } from '../../../api/memberBank'
import { Toast, Indicator, MessageBox } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
import CommonSendCode from '../common/CommonSendCode'
import flexLine from '../../flexLine'
export default {
  name: 'MemberWithdrawList',
  components: {
    flexLine,
    EmptyRecord,
    CommonSendCode
  },
  data() {
    return {
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      bank_length: 0,
      amount: '',
      memberbankList: {},
      memberbankOptions: [],
      memberbank_name: '',
      memberbank_id: '',
      password: '',
      sendAuthCode: false,
      wrapperHeight: 0,
      withdraw_list: false,
      usdt_address: '',
      available_predeposit: 0.00,
      btnShow: true,
      showPassword: false,
    }
  },
  created() {
    getMemberIndex().then(
      response => {
        if (response && response.result.member_info) {
          this.available_predeposit = response.result.member_info.available_predeposit
        }
      },
      error => { }
    )
    getBankList().then(res => {
      let temp = res.result.bank_list
      this.bank_length = temp.length
      if (this.bank_length > 0) {
        this.usdt_address = temp[0].memberbank_no
        this.memberbank_id = temp[0].memberbank_id
      } else {
        this.goMemberbacklist(-2)
        this.btnShow = false
      }
    }).catch(function (error) {
      Toast(error.message)
    })
  },
  computed: {
    ...mapState({
      user: state => state.member.info
    })
  },
  mounted() {
    this.wrapperHeight = document.documentElement.clientHeight - 90
  },
  methods: {
    onPage(v, val) {
      this.$emit('onPage', v, val)
    },
    toggleVisibility() {
      this.showPassword = !this.showPassword;
    },
    onRetrieve() {
      this.$router.push({ name: 'HomeMemberForget', query: { type: 'pay_password' } })
    },
    addWithdraw() {
      let that = this
      if (this.amount == '') {
        Toast(this.$t('Please enter') + this.$t('Withdrawal Amount'))
        return
      }
      MessageBox({
        title: that.$t('MessageBox.Tips'),
        message: that.$t('MessageBox.Confirm') + ' ' + that.$t('Withdraw') + '?',
        confirmButtonText: that.$t('MessageBox.Confirm'),
        cancelButtonText: that.$t('MessageBox.Cancel'),
        showCancelButton: true
      }).then(action => {
        if (action == 'confirm') {

          addWithdraw(this.amount, this.memberbank_id, this.password).then(res => {
            if (res.code == 10000) {
              this.$router.go(0)
            }
            Toast(res.message)

          }).catch(function (error) {
            Toast(error.message)
          })

        }
      })
    },
    goBack() {
      this.$router.go(-1)
    },
    goMemberbacklist(backTo) {
      this.$router.push({ name: 'MemberBankForm', query: { action: 'add', backTo } })
    },
    loadMore() {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getWithdrawList(true)
      }
    },
    getWithdrawList() {
      Indicator.open()

      getWithdrawList(this.params).then(res => {
        Indicator.close()
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }

        let temp = res.result.list
        if (temp) {
          if (!this.withdraw_list) {
            this.withdraw_list = temp
          } else {
            this.withdraw_list = this.withdraw_list.concat(temp)
          }
        }
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.member-withdraw-list {
  min-height: 100vh;
  box-sizing: border-box;
  background: #fff;
}

.centerbox {
  background: #fff;
  padding: 0 1rem;

  .common-btn {
    margin: 1rem;
    background: #E7010C;
  }

  .balance {
    text-align: right;
    font-size: .6rem;
    color: #999;
  }
}

.titlewd {
  background: #fff;
  padding: .5rem;
  font-size: .7rem;
  font-weight: 600;
  margin-top: 1rem;
}

.common-header {
  box-shadow: none;

  .btn {
    background: #000;
    color: #fff;
    box-shadow: 0px 2px 4px #d2d2d2;
  }
}

.main-content {
  background: #fff;
  padding: 0 $pageSpace
}

.container {
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
}

.header {
  border-bottom: 1px solid #e8eaed;
}

.list-wrapper {
  margin-top: 1rem;
  border-radius: 20px;
  border: 1px solid #e8eaed;

  .container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    padding: 0 0 0.75rem 0;
    border-bottom: 1px solid #e8eaed;

    &:last-child {
      border-bottom: none;
    }
  }

  .top-wrapper {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: stretch;
  }

  .left-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
  }

  .right-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
  }

  .status {
    font-size: $subFontSize;
    color: #5296db;
    margin-left: 0.75rem;
    margin-top: 0.65rem;
  }

  .title {
    font-size: $fontSize;
    color: #666666;
    margin-left: 0.75rem;
    margin-top: 0.25rem;
    margin-right: 0.5rem;
    margin-bottom: 0.2rem;
    width: 8rem;
    word-wrap: break-word;
    white-space: normal;
    overflow-wrap: break-word;
  }

  .price {
    font-size: $h1;
    color: $primaryColor;
    margin-right: 0.75rem;
    margin-top: 0.5rem;
    text-align: right;
  }

  .subtitle {
    font-size: $fontSize;
    color: #999999;
    margin-right: 0.75rem;
    margin-top: 0.25rem;
    margin-bottom: 0.5rem;
    text-align: right;
  }

  .top-line {
    position: absolute;
    left: 0.75rem;
    bottom: 0;
    right: 0;
    height: 1px;
    background-color: #e8eaed;
  }

  .desc {
    color: #999999;
    font-size: $fontSize;
    padding: 0.25rem;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
  }

  .center-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    padding-bottom: 0.25rem;
  }
}

.input-wrapper {
  display: flex;
  flex-direction: row;
  align-content: flex-start;
  align-items: center;
  background-color: #fff;

  flex-direction: column;
  align-items: flex-start;
  margin: .4rem 0;

  .field-name {
    width: 100%;
    font-size: 14px;
    font-weight: 600;
    margin: .5rem 0;
  }

  input {
    flex: 1;
    font-size: $subFontSize;
    flex: 1;
    width: 100%;
    text-align: left !important;
    padding: .9rem;
    border-radius: .4rem;
    background: #FAFAFA;
    border-radius: 5px 5px 5px 5px;
  }

  .bottom-input {
    border-bottom-width: 0;
  }

  .field-line-right {
    width: 100%;
    position: relative;
  }

  ::v-deep(.right) {
    width: 100%;
  }
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: .8rem 0;
}

.fundet {
  padding: 0 .5rem;
  background: #FFFFFF;

  .tit {
    color: #E7010C;
    font-size: 14px;
    text-align: center;
  }
}

::v-deep(.flex-line) {
  align-items: flex-start !important;
}
</style>
